import * as React from 'react';

// ネクスト標準のエラーがエラーメッセージをカスタム不能だったため(statusコードのみでの制御だった)
// こちらで同じスタイルで標準エラーコンポーネントを定義。

type Props = {
  heading?: (string | Null) | Null;
  message: string;
};

const CustomError = ({ heading, message }: Props) => (
  <div className="wrapper">
    <div>
      {heading && <h1 className="heading">{heading}</h1>}
      <div className="msg-wrapper">
        <h2 className="msg">{message}</h2>
      </div>
    </div>
    <style jsx>
      {`
        .wrapper {
          color: #000;
          background: #fff;
          font-family: -apple-system, BlinkMacSystemFont, Roboto, 'Segoe UI', 'Fira Sans', Avenir,
            'Helvetica Neue', 'Lucida Grande', sans-serif;
          /* heightにcalcしているのはfooter/headerの高さを引いているため */
          height: calc(100vh - 48px - 240px);
          text-align: center;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }
        .msg-wrapper {
          display: inline-block;
          text-align: left;
          line-height: 49px;
          height: 49px;
          vertical-align: middle;
        }
        .heading {
          display: inline-block;
          border-right: 1px solid rgba(0, 0, 0, 0.3);
          margin: 0;
          margin-right: 20px;
          padding: 10px 23px 10px 0;
          font-size: 24px;
          font-weight: 500;
          vertical-align: top;
        }
        .msg {
          font-size: 14px;
          font-weight: normal;
          line-height: inherit;
          margin: 0;
          padding: 0;
          padding-top: 2px;
        }
      `}
    </style>
  </div>
);

CustomError.defaultProps = {
  heading: null,
};

export default CustomError;
